// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  background-color: #104A6F;
}

#my_games {
  margin-top: 0px;
  margin-left: 5px;
  margin-right: 0px;
  overflow: auto;
}

.clearTopMargin {
  margin-top: 0px !important;
}

.full-screen-btn {
  background-color: #ddd !important;
  color: var(--ion-color-dark);
  cursor: pointer !important;
}

.close-btn {
  float: right;
  margin: 2px !important;
  width: 54px;
  height: 40px;
  color: var(--ion-color-light) !important;
  background: transparent;
  background-color: transparent;
}
.close-btn:hover {
  background-color: transparent !important;
}
.close-btn .button-inner {
  background: transparent !important;
  font-size: 2.3rem !important;
  cursor: pointer !important;
}

.game-wrapper-bar {
  font-size: 0.8rem;
  color: white;
  align-items: end;
  display: flex;
  padding: 0px;
}
.game-wrapper-bar .btn-container {
  margin: auto;
  align-items: flex-end;
  flex: 5;
  justify-content: flex-end;
  display: flex;
}
.game-wrapper-bar .button {
  height: 2rem;
  color: var(--ion-color-light);
}
.game-wrapper-bar .full-screen-btn {
  background-color: transparent !important;
  width: 20px;
  border: 2px solid #000;
  border-radius: 5px;
}
.game-wrapper-bar .full-screen-btn span {
  font-size: 0.9rem;
}

.netPositionBar {
  color: wheat;
  padding: 0 10px 0 10px;
  height: 30px;
  align-items: center;
  justify-content: center;
  display: flex;
  border: 1px solid white;
  border-radius: 5px;
  margin: 5px;
}
@media screen and (max-width: 375px) {
  .netPositionBar {
    padding: 0 6px 0 6px;
    margin: 2px;
    height: 25px;
    font-size: 8px;
    position: absolute;
    right: 42px;
  }
}

.time-online {
  color: white;
  padding: 0 10px 0 10px;
  height: 30px;
  align-items: center;
  justify-content: center;
  display: flex;
  border: 1px solid white;
  border-radius: 5px;
  margin: 5px;
}
@media screen and (max-width: 375px) {
  .time-online {
    padding: 0 6px 0 6px;
    margin: 2px;
    height: 25px;
    font-size: 8px;
  }
}

.game-iframe {
  transform: translate3d(0, 0, 0) !important; /* Trigger GPU acceleration */
  backface-visibility: hidden; /* Improve GPU performance on 3D transforms */
  will-change: transform, opacity; /* Optimize for potential changes */
  contain: strict; /* Isolate the iframe's layout and painting */
  border: none; /* Remove the border for cleaner appearance */
}

.game-iframe-content-iosweb-div {
  padding-bottom: 5px;
}

.icon-style {
  height: 18px;
  width: 18px;
  display: inline-block;
  object-fit: fill;
  color: var(--ion-color-light) !important;
}

.custom-scale {
  scale: 1.5;
}

.heading {
  color: var(--ion-color-light) !important;
  font-weight: 500;
  font-size: 1rem;
  text-align: center;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
}

.heading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: flex-end;
  flex: 1;
  flex-direction: row;
}`, "",{"version":3,"sources":["webpack://./src/app/components/game/game.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAEJ;;AAAA;EACI,0BAAA;AAGJ;;AAAA;EACI,iCAAA;EACA,4BAAA;EACA,0BAAA;AAGJ;;AACA;EACI,YAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,uBAAA;EACA,6BAAA;AAEJ;AADI;EACI,wCAAA;AAGR;AADI;EACI,kCAAA;EACA,4BAAA;EACA,0BAAA;AAGR;;AAAA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAGJ;AADI;EACI,YAAA;EACA,qBAAA;EACA,OAAA;EACA,yBAAA;EACA,aAAA;AAGR;AAAI;EACI,YAAA;EACA,6BAAA;AAER;AAAI;EACI,wCAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AAER;AADQ;EACI,iBAAA;AAGZ;;AAEA;EACI,YAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AACJ;AAAI;EAVJ;IAWQ,oBAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;EAGN;AACF;;AACA;EACI,YAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;AAEJ;AAAI;EAXJ;IAYQ,oBAAA;IACA,WAAA;IACA,YAAA;IACA,cAAA;EAGN;AACF;;AACA;EACI,0CAAA,EAAA,6BAAA;EACA,2BAAA,EAAA,6CAAA;EACA,+BAAA,EAAA,mCAAA;EACA,eAAA,EAAA,6CAAA;EACA,YAAA,EAAA,6CAAA;AAEJ;;AACA;EACI,mBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,wCAAA;AAGJ;;AADA;EACI,UAAA;AAIJ;;AADA;EAEI,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,yBAAA;EACA,OAAA;EACA,mBAAA;AAEJ","sourcesContent":["ion-grid {\n    background-color: #104A6F;\n}\n#my_games {\n    margin-top: 0px;\n    margin-left: 5px;\n    margin-right: 0px;\n    overflow: auto;\n}\n.clearTopMargin {\n    margin-top: 0px!important;\n}\n\n.full-screen-btn {\n    background-color: #ddd !important;\n    color: var(--ion-color-dark);\n    cursor: pointer!important;\n}\n\n\n.close-btn{\n    float: right;\n    margin: 2px!important;\n    width: 54px;\n    height: 40px;\n    color: var(--ion-color-light)!important;\n    background: transparent;\n    background-color: transparent;\n    &:hover{\n        background-color: transparent!important;\n    }\n    .button-inner {\n        background: transparent !important;\n        font-size: 2.3rem!important;\n        cursor: pointer!important;\n    }\n}\n.game-wrapper-bar {\n    font-size: 0.80rem;\n    color:white;\n    align-items: end;\n    display: flex;\n    padding: 0px;\n    \n    .btn-container{\n        margin: auto;\n        align-items: flex-end;\n        flex: 5;\n        justify-content: flex-end;\n        display: flex;\n\n    }\n    .button {\n        height: 2rem;\n        color: var(--ion-color-light);\n    }\n    .full-screen-btn {\n        background-color: transparent!important;\n        width: 20px;\n        border:2px solid #000;\n        border-radius: 5px;\n        span {\n            font-size: 0.9rem;\n        }\n    }\n}\n\n.netPositionBar{\n    color: wheat;\n    padding: 0 10px 0 10px;\n    height: 30px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    border: 1px solid white; \n    border-radius: 5px;\n    margin: 5px;\n    @media screen and (max-width: 375px) {\n        padding: 0 6px 0 6px;\n        margin: 2px;\n        height: 25px;\n        font-size: 8px;\n        position: absolute;\n        right:42px;\n      }\n        \n}\n\n.time-online {\n    color: #ffff;\n    padding: 0 10px 0 10px;\n    height: 30px;\n    align-items: center;\n    justify-content: center;\n    display: flex;\n    border: 1px solid #ffff; \n    border-radius: 5px;\n    margin: 5px;\n\n    @media screen and (max-width: 375px) {\n        padding: 0 6px 0 6px;\n        margin: 2px;\n        height: 25px;\n        font-size: 8px;\n      }\n        \n}\n\n.game-iframe {\n    transform: translate3d(0, 0, 0) !important; /* Trigger GPU acceleration */\n    backface-visibility: hidden; /* Improve GPU performance on 3D transforms */\n    will-change: transform, opacity; /* Optimize for potential changes */\n    contain: strict; /* Isolate the iframe's layout and painting */\n    border: none; /* Remove the border for cleaner appearance */\n}\n\n.game-iframe-content-iosweb-div{\n    padding-bottom: 5px;\n}\n.icon-style{\n    height: 18px; \n    width: 18px; \n    display: inline-block;\n    object-fit:fill; \n    color:  var(--ion-color-light) !important;\n}\n.custom-scale{\n    scale: 1.5;\n}\n  \n.heading{\n\n    color:  var(--ion-color-light) !important;\n    font-weight: 500;\n    font-size: 1rem;\n    text-align: center;\n    flex: 1;\n    white-space: nowrap;\n    overflow: hidden;\n    \n  \n}\n.heading-container {\n    display: flex; \n    flex-direction: column; \n    align-items: center;\n    height: 100%; \n    justify-content: flex-end;\n    flex: 1;\n    flex-direction: row;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
